export default __webpack_public_path__ + "static/08-12761b640a0678a9fa27825daf07d7cf.jpg";